export default __webpack_public_path__ + "static/media/116_desktop.ecc084f8.jpg";